export const TIMELINE_FIXED_FIELD_COLUMN_WIDTH = 200;
export const TIMELINE_FIXED_FIELD_DIVIDER_WIDTH = 1;
export const TIMELINE_FIXED_PANE_TOGGLE_WIDTH = 48;
export const TIMELINE_FIXED_PANE_MAX_WIDTH_RATIO = 0.5;
export const TIMELINE_DAY_WIDTH = 28;
export const TIMELINE_WEEK_WIDTH = 250;
export const TIMELINE_WEEK_DAY_WIDTH = TIMELINE_WEEK_WIDTH / 7;
export const TIMELINE_MONTH_WIDTH = 270;
export const TIMELINE_QUARTER_WIDTH = 300;
export const TIMELINE_QUARTER_MONTH_WIDTH = TIMELINE_QUARTER_WIDTH / 3;
export const TIMELINE_HEADER_HEIGHT = 40;
export const TIMELINE_ROW_HEIGHT = 40;
export const TIMELINE_ADD_ENTRY_ROW_HEIGHT = 40;
// Matches the host's 8px trailing gutter plus the Timeline's 1px card edge.
export const TIMELINE_TRAILING_ACTION_GUTTER_WIDTH = 9;
export const TIMELINE_BAR_HEIGHT = 26;
export const TIMELINE_MIN_BAR_WIDTH = 35;
export const TIMELINE_INVALID_RANGE_BAR_WIDTH = 20;
export const TIMELINE_ONE_SIDED_BAR_WIDTH = 60;
export const TIMELINE_BAR_VERTICAL_INSET =
  (TIMELINE_ROW_HEIGHT - TIMELINE_BAR_HEIGHT) / 2;
export const TIMELINE_BAR_INSET = 0;
export const TIMELINE_MONTH_BUFFER_MONTHS = 24;
